<template>
  <div
    class="bg-gray-300 min-h-screen flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
  >
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span
    >&#8203;
    <div
      v-show="signingOut"
      class="inline-block align-bottom bg-white rounded-b-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <sqr-progress />
      <div class="px-4 pt-5 pb-4 sm:p-6">
        <div>
          <div class="text-center sm:mt-5">
            <h3
              class="text-lg leading-6 font-medium text-gray-900"
              id="modal-headline"
            >
              {{ $t('sign_out_title') }}
            </h3>
            <div class="mt-2">
              <p class="text-sm leading-5 text-gray-500">
                {{ $t('sign_out_subtitle') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="!signingOut"
      class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div>
        <div
          class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
        >
          <CheckCircleIcon class="h-6 w-6 text-green-600" />
        </div>
        <div class="mt-3 text-center sm:mt-5">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            {{ $t('sign_out_finished_title') }}
          </h3>
          <div class="mt-2">
            <p class="text-sm leading-5 text-gray-500">
              {{ $t('sign_out_finished_subtitle') }}
            </p>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-6">
        <span class="flex w-full rounded-md shadow-sm">
          <router-link :to="{ name: 'sign-in' }" class="w-full">
            <sqr-button
              class="w-full"
              :label="$t('sign_out_sign_back')"
              color="green"
            />
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon } from '@vue-hero-icons/outline';
import { mapActions } from 'vuex';
import SqrButton from '@/components/SqrButton';
import SqrProgress from '@/components/SqrProgress';
export default {
  name: 'SignOut',
  components: { SqrButton, SqrProgress, CheckCircleIcon },
  data() {
    return {
      signingOut: false,
      signOutError: null
    };
  },
  mounted() {
    this.$a().logEvent('sign_out');
    this.process();
  },
  methods: {
    ...mapActions('auth', ['signOut']),
    async process() {
      try {
        this.signingOut = true;
        await this.signOut();
      } catch (error) {
        this.signOutError = error;
      } finally {
        this.signingOut = false;
      }
    }
  }
};
</script>
